import type { KsActItem } from '@shared/api';
import { Badge } from '@shared/ui/Badge';
import { fmtMoney, fmtNum } from '@shared/lib/smetaLabels';
import { MutedMargin, Table, ThRight } from './styled';

interface ActItemsTableProps {
  items: KsActItem[];
}

export function ActItemsTable({ items }: ActItemsTableProps) {
  if (items.length === 0) {
    return <MutedMargin>Позиции не извлечены.</MutedMargin>;
  }
  return (
    <Table>
      <thead>
        <tr>
          <th>Поз.</th>
          <th>Шифр</th>
          <th>Наименование</th>
          <th>Ед.</th>
          <ThRight>Объём</ThRight>
          <ThRight>Цена ед.</ThRight>
          <ThRight>Стоимость</ThRight>
          <th>Эталон</th>
        </tr>
      </thead>
      <tbody>
        {items.map((it) => (
          <tr key={it.id}>
            <td>{it.position_no ?? '—'}</td>
            <td>{it.code}</td>
            <td>{it.name}</td>
            <td>{it.unit ?? '—'}</td>
            <td className="num">{fmtNum(it.qty_period)}</td>
            <td className="num">{fmtMoney(it.unit_price)}</td>
            <td className="num">{fmtMoney(it.cost_period)}</td>
            <td>
              {it.matched_estimate_item_id ? (
                <Badge $tone="success">сматчено</Badge>
              ) : (
                <Badge $tone="neutral">нет</Badge>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
